import { BookkeepingTag, getTaxRateFromBookkeepingTagAnswer, getTaxRateFromRegionAndValue } from '@components'

import { AttachmentParsedVatSummary } from 'src/types/attachmentParsedVatSummary'
import { Region } from 'src/types/region'

import { TaxRate } from '@modules-deprecated/app/taxrates/types'

import { BillFormLine } from '../elements/BillEditableForm/utils/formData'

interface BuildBillLinesProps {
  vatSummary: AttachmentParsedVatSummary[] | null
  existingTag: BookkeepingTag | undefined
  region: Region | undefined
  taxRates: TaxRate[] | undefined
  hasVATdetected: boolean | undefined
  amounts: {
    totalInclVat: number | null
    totalVat: number | null
  }
}

export const buildBillLines = ({
  vatSummary,
  existingTag,
  region,
  taxRates,
  hasVATdetected,
  amounts,
}: BuildBillLinesProps): Partial<BillFormLine>[] => {
  if ((vatSummary?.length ?? 0) > 0) {
    return (
      vatSummary?.map((item: AttachmentParsedVatSummary) => ({
        inclVatAmount: item.amountInclVat ?? undefined,
        hasVATdetected,
        taxRate: getTaxRateFromRegionAndValue({
          region,
          value: hasVATdetected ? item.rate : 0,
          taxRates,
        }),
      })) ?? []
    )
  }

  if (existingTag) {
    return [
      {
        inclVatAmount: amounts.totalInclVat ?? undefined,
        hasVATdetected,
        taxRate: getTaxRateFromBookkeepingTagAnswer({
          answer: existingTag.vatRates,
          taxRates,
          region,
          hasVATdetected,
        }),
      },
    ]
  }

  return [
    {
      inclVatAmount: amounts.totalInclVat ?? undefined,
      hasVATdetected,
    },
  ]
}
